import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { map } from 'rxjs/operators';
import { AbstractControl, ValidatorFn } from '@angular/forms';
import { never } from 'rxjs';

const routes = {
  commonPassword: "/file/load-common-password"
};

const GET_IMPORT_LOT_BY_ID = '/import-lot/get-by-id/';
const GET_ALL_PROCESSING = '/import-lot/get-all-processing';
const CREATE_IMPORT_LOT = '/import-lot/create';
const GET_RESULT_FILE = '/import-lot/get-result-file/'

@Injectable({
  providedIn: 'root'
})
export class PasswordService {

  commonPassword= null;
  isLoading = false;

  constructor(private apiService: ApiService) { }

  validateCommonPassword(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      if (!control.value) {
        return null;
      }
      if(this.isLoading){

      }
      if (!this.commonPassword) {
        this.isLoading = true;
        this.apiService.get(routes.commonPassword).subscribe(res => {
          this.isLoading = false;
          // console.log(res);
          if(res && !res.success){
            this.commonPassword = ['qwerty','password','passw0rd','password@123','abc123','iloveyou','iloveu','admin@123','user@123','abc@123','123qwea@','qwerty@123','123@123','123123','696969','123456a@','12345678a@','123456aA@','123456a@A','111111a@']
          }
          else{
            this.commonPassword = res.data['CONTAIN'];
          }

          return this.validatePattern(control.value) ? null : { invalidContainPattern: true }
        })
      }
      else {
        return this.validatePattern(control.value) ? null : { invalidContainPattern: true }
      }
    };
  }

  validatePattern(value: string) {
    //contains
    // console.log(this.commonPassword)
    if(this.commonPassword){
      return !(new RegExp(this.commonPassword.join("|")).test(value))
    }
    return false;
  }
}
